import { TextField, Autocomplete } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import Translate from "../../utils/Translate";
import { useApi } from "../../utils/Api";
import Preloader from "../Preloader";
import { DatePicker } from "@mui/x-date-pickers";
import { getCurrentDateMask, getCurrentInputFormat } from "../../utils/dateTimeFormat";
import { accessKeys, hasSomeAccess } from "../../utils/userAccess";

export default function SelectActorPermitDetails({
  otherEquipment,
  onOtherEquipmentChange,
  task,
  onTaskChange,
  area,
  onAreaChange,
  permitStartDate,
  onPermitStartDateChange,
  permitEndDate,
  onPermitEndDateChange,
  startDateErrorMessage,
  suggestedValues,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const freeSoloCombo = (suggestedValues, value, onChange, maxLength, label, required, multiline = false, rows = 3) => {
    return (
      <Autocomplete
        fullWidth
        freeSolo
        options={suggestedValues}
        value={value}
        onChange={(_, value) => onChange(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{ ...params.inputProps, maxLength: maxLength }}
            variant="outlined"
            label={label}
            multiline={multiline}
            rows={rows}
            onChange={(event) => onChange(event.target.value)}
            required={required}
          />
        )}
      />
    );
  };

  return (
    <>
      {isLoading && <Preloader />}
      {!isLoading && (
        <Grid container columnSpacing={0} rowSpacing={2} direction="column" style={{ margin: 0, padding: 0 }}>
          <div className="smallHeader">{Translate.get("OtherDetails")}</div>
          <Grid >
            {freeSoloCombo(
              suggestedValues?.task ?? [],
              task,
              (newValue) => onTaskChange(newValue),
              250,
              Translate.get("WorkTasks"),
              true,
              true,
            )}
          </Grid>
          <Grid container direction="row" spacing={2}>
            <Grid size={{ xs: 12, md: 12 }}>
              {freeSoloCombo(
                suggestedValues?.equipment ?? [],
                otherEquipment,
                (newValue) => onOtherEquipmentChange(newValue),
                100,
                Translate.get("OtherEquipment"),
              )}
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              {freeSoloCombo(
                suggestedValues?.area ?? [],
                area,
                (newValue) => onAreaChange(newValue),
                250,
                Translate.get("InAreaOf"),
                false,
                true,
                null, // rows = null gör att fältet växer automatiskt när man trycker retur
              )}
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <DatePicker
                displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
                format={getCurrentInputFormat()}
                mask={getCurrentDateMask()}
                label={Translate.get("ValidFrom")}
                value={permitStartDate}
                onChange={(newValue) => {
                  onPermitStartDateChange(newValue);
                  if (newValue && permitEndDate && newValue > permitEndDate) {
                    onPermitEndDateChange(newValue);
                  }
                }}
                slotProps={{ textField: { required: true, error: !!startDateErrorMessage, helperText: startDateErrorMessage, fullWidth: true } }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <DatePicker
                displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
                format={getCurrentInputFormat()}
                mask={getCurrentDateMask()}
                label={Translate.get("ValidTo")}
                value={permitEndDate}
                onChange={(newValue) => {
                  onPermitEndDateChange(newValue);
                }}
                slotProps={{ textField: { fullWidth: true } }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}></Grid>
            <Grid style={{ marginTop: "0.2em", paddingTop: 0 }} size={{ xs: 12, sm: 6 }}>
              <div className="smallInfoText">{Translate.get("NoEndDateValid")}</div>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
